// tanstack
import { createFileRoute } from '@tanstack/react-router';

// components
import DashboardPage from '@/features/dashboards/DashboardPage';

export const Route = createFileRoute('/$accountId/_user/dashboards/')({
  component: DashboardPage,
});
